import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogContent } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { CurrentUser } from '../../models/current-user';
import { USER_ROLE_I18N_KEY } from '../../models/user-role';

@Component({
    selector: 'apcam-profile-detail',
    templateUrl: './profile-detail.component.html',
    styleUrls: ['./profile-detail.component.scss'],
    imports: [
        CdkConnectedOverlay,
        CdkOverlayOrigin,
        MatButtonModule,
        MatCardModule,
        MatDialogContent,
        MatDividerModule,
        MatIconModule,
        TranslatePipe,
    ],
})
export class ProfileDetailComponent {
    /**
     * Input property representing the current user information.
     */
    @Input()
    currentUser!: CurrentUser;

    isOpen: boolean = false;

    /**
     * Evaluates whether the profile detail in the nav bar shall hide the profile's role.
     * Typically, clients do not have any role, and it does not need to be displayed, admins
     * and case managers have their roles displayed.
     */
    protected hideRole(): boolean {
        return this.currentUser && this.currentUser.role == null;
    }

    protected roleTranslationKey(): string {
        return `shared.skeleton.profileDetails.roles.${USER_ROLE_I18N_KEY[this.currentUser.role!]}`;
    }
}
